import { useEffect, useState, useRef } from 'react';
import { notification } from 'antd';
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';

import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import SchoolCard from '../../components/SchoolCard/SchoolCard';
import { responsive } from '../../data';
import SchoolSubjectCard from '../../components/LearnSubjectCard/SchoolSubjectCard';
//import { getSchools, getSubjects } from "../../services/learnService";
import { tutors } from '../../dummyData';

import Carousel from 'react-multi-carousel';
//import { getTutors } from "../../services/tutorService";
import { getPaidCourse } from '../../services/paymentService';
import Spinner from '../../components/Spinner/Spinner';
import { baseURL } from '../../utils/axios';
import Article from '../../assets/icons/Article';
import ReactPixel from 'react-facebook-pixel';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ReactPixel.pageView(); // Track a page view event
  }, []);

  let studentData = JSON.parse(localStorage.getItem('userData'));
  const [schools, setSchools] = useState([]);
  const [subjects, setSubjects] = useState([]);
  //const [tutors, setTutors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paidCourses, setPaidCourses] = useState([]);

  let token = localStorage.getItem('token');

  useEffect(() => {
    const getAllSchools = async () => {
      const res = await fetch(`${baseURL}/schools`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSchools(data.data.schools);
      }

      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        localStorage.clear();
        navigate('/login');
      }
    };
    getAllSchools();
  }, []);

  useEffect(() => {
    let { id } = JSON.parse(localStorage.getItem('userData'));

    const getPaidCourses = async () => {
      try {
        setLoading(true);
        let course = await getPaidCourse(id, token);
        setPaidCourses(course.data.courses);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    getPaidCourses();
  }, []);

  const bottomRef = useRef(null);
  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <>
      <Helmet>
        <title>PL by Edves | Dashboard</title>
      </Helmet>
      <DashboardHeader />
      <div className='dashboard-hero'>
        <h1>
          Let’s start learning,{' '}
          <span style={{ textTransform: 'capitalize' }}>
            {studentData?.first_name}
          </span>
        </h1>
        <p>
          We have recommended top schools that match your academic preferences,
          connect with <br /> any school of your choice and start your
          personalized learning journey on PL by Edves.
        </p>
      </div>

      <div className='dashboard-body' style={{ marginTop: '60px' }}>
        {loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spinner />
          </div>
        ) : paidCourses.length === 0 ? (
          // <div>No subjects found </div>
          <div
            className='tutor-dashboard__left__second-card'
            style={{
              width: '100%',
              boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            }}
          >
            <Article />
            <h2 className='tutor-dashboard__left__second-card__title'>
              No subject yet
            </h2>
            <p className='tutor-dashboard__left__second-card__subtitle'>
              You have not bought any subject yet, once you buy a subject, all
              your lessons will appear here.
            </p>
            <div className='tutor-dashboard__left__second-card__btn'>
              <button onClick={() => scrollToBottom()}>Buy Now</button>
            </div>
          </div>
        ) : (
          <>
            <div
              className='recommended-section__title'
              style={{ marginBottom: '40px' }}
            >
              <h2>Your lessons</h2>
              <p>
                Enjoy learning resources from A- list schools across the world{' '}
              </p>
            </div>

            <Carousel
              responsive={responsive}
              showDots={true}
              itemClass={`carouselItem`}
            >
              {paidCourses.length === 0 ? (
                <div></div>
              ) : (
                paidCourses.map((el, index) => (
                  <SchoolSubjectCard
                    key={el.id}
                    schoolHeader={
                      el?.id === 6
                        ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680096219/WhatsApp_Image_2023-03-29_at_13.50.08_hqqdcv.jpg'
                        : el?.title?.toLowerCase()?.includes('biology')
                        ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833246/4_ywa1uq.jpg'
                        : el?.title?.toLowerCase()?.includes('mathematics')
                        ? 'https://leverageedu.com/blog/wp-content/uploads/2020/07/Branches-of-Mathematics.png'
                        : el?.title?.toLowerCase()?.includes('english')
                        ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrP9mK3dTuXB86woJ2JW7J8TkxszYhRVk_4Q&usqp=CAU'
                        : el.title?.toLowerCase().includes('food')
                        ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680783147/food_and_nutrition_lqxah9.png'
                        : el.title?.toLowerCase().includes('economics')
                        ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833433/9_eknlh0.jpg'
                        : el.title?.toLowerCase().includes('technical')
                        ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833564/3_tzp8za.jpg'
                        : el.title?.toLowerCase().includes('yoruba')
                        ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1697073430/ce8719b2-2829-4e2d-b3c1-fe11763ee02b_idb5h9.jpg'
                        : el.banner
                    }
                    index={index}
                    id={el.id}
                    subject={el.name}
                    description={el.description || `by ${el.school?.name}`}
                    topic={el.title}
                    duration={el.duration}
                    maxStudents={el.max_students}
                    lessonStyle={el.lesson_style}
                    lessonCount={el.topics_count}
                    studentCount={el.students_count}
                    currency={el.currency.symbol}
                    subjectClass={el.subject_class.title}
                    // selectSchool={() => {
                    //   navigate(`/learn/${el.id}/${el.school.id}`);
                    // }}
                    selectSchool={() => {
                      navigate(
                        `/view-subject/${el.title}-${el.id}?school=${el.school.id}`
                      );
                    }}
                    page='dashboard'
                  />
                ))
              )}
            </Carousel>
          </>
        )}
      </div>
      <div ref={bottomRef} />

      <div className='dashboard-body' style={{ marginTop: '60px' }}>
        <div
          className='recommended-section__title'
          style={{ marginBottom: '40px' }}
        >
          <h2>Learn from A- list schools</h2>
          <p>Explore subjects taken by schools on PL </p>
        </div>
        {schools.length === 0 ? (
          <div>No schools found</div>
        ) : (
          <Carousel
            responsive={responsive}
            showDots={true}
            itemClass={`carouselItem`}
          >
            {/* <div className="dashboard-body__subject-row"> */}
            {schools.length === 0 ? (
              <div></div>
            ) : (
              schools?.map((el) => (
                <SchoolCard
                  key={el.id}
                  schoolLogo={el.logo}
                  schoolHeader={el.banner ? el.banner : el.logo}
                  schoolName={el.name}
                  subjectNo={el.courses_count}
                  description={el.bio}
                  location={`${el.country ? el.country : 'Nigeria'}`}
                  lessonCount={el.lessons_count}
                  selectSchool={() => {
                    navigate(`/schools/${el.link_id ? el.link_id : el.id}`);
                  }}
                  page='dashboard'
                  type='school'
                />
              ))
            )}
            {/* </div> */}
          </Carousel>
        )}
      </div>

      <div className='dashboard-body' style={{ marginTop: '60px' }}>
        <div
          className='recommended-section__title'
          style={{ marginBottom: '40px' }}
        >
          <h2>Top tutors for quick learning</h2>
          <p>Explore topics taken by tutors on PL </p>
        </div>
        {tutors.length === 0 ? (
          <div>No tutors found</div>
        ) : (
          <Carousel
            responsive={responsive}
            showDots={true}
            itemClass={`carouselItem`}
          >
            {/* <div className="dashboard-body__subject-row"> */}
            {tutors?.map((el) => (
              <SchoolCard
                key={el.id}
                schoolLogo={el.avatar}
                schoolHeader={el.banner}
                schoolName={el.first_name}
                subjectNo={el.courses_count}
                description={el.summary}
                location={el.location}
                lessonCount={el.lessons_count}
                selectSchool={() => {
                  navigate(`/tutors/${el.id}`);
                }}
                type='tutor'
                page='dashboard'
              />
            ))}
            {/* </div> */}
          </Carousel>
        )}
      </div>
    </>
  );
};

export default Dashboard;
